import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import Swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-two-factors-authentication',
  templateUrl: './two-factors-authentication.component.html',
  styleUrls: ['./two-factors-authentication.component.css']
})
export class TwoFactorsAuthenticationComponent {

  public key: string = "";
  public QRCode: string = "";
  public manualCode: string = "";
  public OTP: string = "";

  constructor(private dialogRef: MatDialogRef<TwoFactorsAuthenticationComponent>, private authService: AuthService, private toastr: ToastrService, @Inject(MAT_DIALOG_DATA) private data: any) {
    this.authService.getTwoFactorsAuthentication().subscribe(src => {
      if (src) {
        this.key = src.Key;
        this.QRCode = src.QRCode;
        this.manualCode = src.ManualCode;
      }
    });
  }

  back(): void {
    this.dialogRef.close();
  }

  save(): void {
    console.log(this.OTP);
    this.authService.setTwoFactorsAuthentication(this.OTP, this.key).subscribe(res => {
      Swal("Autenticazione", "Autenticazione a due fattori abilitata", "success");
      this.authService.getManageInfo().subscribe(res => {
        this.back();
      })
    }, error => {
    });
  }

  ngOnInit(): void {
  }
}



// WEBPACK FOOTER //
// ./src/app/two-factors-authentication-component/two-factors-authentication.component.ts